module.exports = __webpack_public_path__ + "60801dde529d14efb4a218b3bb6217e8.pdf";